import React from "react";
import { cn } from "./cn";

/**
 * Bun wizard pop-in cards. Spec: components/feedback/TipCard.
 * kind="tip" (default): white card, amber bulb disc, caps "Did you know?"
 * label. kind="encouragement": blue tint card, chat-bubble disc, blue text.
 * Pass animate to play the 0.45s rise when the card appears.
 */
export default function TipCard({ kind = "tip", label = "Did you know?", animate, className, children }) {
  const enc = kind === "encouragement";
  return (
    <div
      className={cn(
        "flex gap-[11px] rounded-bun-lg border px-[15px] py-[13px] font-instrument",
        enc ? "bg-bun-tint-blue border-bun-tint-blue-line" : "bg-bun-surface border-bun-line",
        animate && "bun-rise",
        className
      )}
    >
      <span
        className={cn(
          "inline-flex items-center justify-center w-[30px] h-[30px] rounded-full shrink-0",
          enc ? "bg-bun-ring text-bun-blue-hover" : "bg-bun-warning-disc text-bun-warning-disc-text"
        )}
      >
        {enc ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-4 4v-4z" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        )}
      </span>
      <div className="self-center min-w-0">
        {!enc && (
          <div className="text-[10.5px] font-semibold uppercase tracking-[0.07em] text-bun-stone">
            {label}
          </div>
        )}
        <div
          className={cn(
            "text-bun-body leading-relaxed",
            enc ? "font-medium text-bun-blue-hover" : "font-book text-bun-slate mt-[2px]"
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
